/**
 * History Settings CMS Model
 * Defines the structure for history module configuration
 */

const HistorySettings = {
  type: "HistorySettings",
  label: "History Settings",
  description: "Configure history tracking behavior and retention",
  localOnly: true,
  icon: "ClockIcon",

  fields: [
    {
      id: "exclude_models",
      type: "Array",
      item: "Text",
      label: "Exclude Models",
      description: "Model names to exclude from history tracking (e.g., Session, TempData, Cache). These models will not have their changes tracked.",
      placeholder: "Enter model name",
      default: [],
      required: false
    },
    {
      id: "exclude_changes",
      type: "Array",
      item: "Text",
      label: "Exclude Field Changes",
      description: "Field names to exclude from change tracking across all models (e.g., lastLogin, viewCount, accessTimestamp).",
      placeholder: "Enter field name",
      default: [],
      required: false
    },
    {
      id: "exclude_tags",
      type: "Array",
      item: "Text",
      label: "Exclude Tags",
      description: "Tags to exclude from history tracking. Events with these tags will not be recorded.",
      placeholder: "Enter tag",
      default: [],
      required: false
    },
    {
      id: "retention_days",
      type: "Number",
      label: "Retention Period (Days)",
      description: "Number of days to keep history entries. Set to 0 to keep history forever. Old entries will be automatically cleaned up.",
      default: 90,
      min: 0,
      max: 3650, // ~10 years
      required: false
    },
    {
      id: "track_all_models",
      type: "Boolean",
      label: "Track All Models",
      description: "When enabled, all models are tracked by default (except those in exclude list). When disabled, only explicitly configured models are tracked.",
      default: true,
      required: false
    },
    {
      id: "store_deltas",
      type: "Boolean",
      label: "Store Field Deltas",
      description: "Store before/after values for changed fields. Requires more storage but enables detailed change history.",
      default: false,
      required: false
    },
    {
      id: "max_changelog_length",
      type: "Number",
      label: "Max Changelog Length",
      description: "Maximum number of characters for changelog field. Longer changelogs will be truncated.",
      default: 1000,
      min: 100,
      max: 10000,
      required: false
    }
  ],

  // ParamIO mapping - maps field IDs to ParamIO addresses
  paramMapping: {
    exclude_models: "History.exclude_models",
    exclude_changes: "History.exclude_changes",
    exclude_tags: "History.exclude_tags",
    retention_days: "History.retention_days",
    track_all_models: "History.track_all_models",
    store_deltas: "History.store_deltas",
    max_changelog_length: "History.max_changelog_length"
  }
}

export default HistorySettings
